import core, { View } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { LIVE_SPORTEVENT_STATUSES, SportEventMetaKey } from 'app-constants';
import { useMemoSelector } from 'hooks';

const {
    entities: {
        selectors: { selectMatchMeta },
    },
    viewport: {
        selectors: { selectIsSmall },
    },
} = core;

interface Input {
    sportEvent: View.Match;
    text: string | null;
}

interface Output {
    text: string | null;
}

export default function useFixtureDataDota({
    sportEvent,
    text,
}: Input): Output {
    const { meta } = useMemoSelector(makeSelectProps(), {
        matchId: sportEvent.id,
    });

    const { status } = sportEvent;

    const isLive = LIVE_SPORTEVENT_STATUSES.includes(status);

    if (isLive) {
        const bo = meta.find(item => item.name === SportEventMetaKey.Bo);

        const boName = bo?.name || '';
        const boValue = bo?.value || '';

        const boData =
            boName && boValue
                ? `${boName.toUpperCase()}${boValue.toUpperCase()}:`
                : '';

        return {
            text: `${boData}${text || ''}`,
        };
    }

    return {
        text,
    };
}

const makeSelectProps = () =>
    createStructuredSelector({
        meta: selectMatchMeta,
        isSmall: selectIsSmall,
    });
